import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getLeaseAgreement(
  pathname,
  queryParams = "",
  extraHeaders = {},
) {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams, {
    headers: extraHeaders,
  }); // pathname is "/role"
}

export async function createLeaseAgreement(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/lease-agreement" + pathname, body);
}

export async function updateLeaseAgreement(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/lease-agreement" + pathname, body);
}

export async function acceptOfferLeaseAgreement(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/lease-agreement" + pathname, body);
}

export async function deleteLeaseAgreement(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).delete("/lease-agreement" + pathname, { data: body });
}

export async function bulkCreateLeaseAgreement(offeringList) {
  return await instance({ baseURL }).post("/lease-agreement/bulk", {
    offerings: offeringList,
  });
}

export async function generateLeaseAgreement(
  pathname,
  queryParams,
) {
  return await instance({
    baseURL: baseURL,
  }).post("/lease-agreement" + pathname + queryParams);
}
